import * as actions from "./actions";

export const setLoading = (loading: any, message: any = "") => {
	return (dispatch: any, data: any) => {
		dispatch(actions.setLoadingSuccess({ loading, message }));
	};
};
